import { motion } from "framer-motion";
import { Phone, WhatsappLogo } from "@phosphor-icons/react";

export default function FloatingActions() {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.6, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 2.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="fixed bottom-6 right-6 z-50 flex flex-col gap-3"
            data-testid="floating-actions"
        >
            <a
                href="https://wa.me/919711220094?text=Hi%20Akash%20Group%2C%20I%20need%20a%20transport%20quote."
                target="_blank"
                rel="noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="floating-whatsapp-button"
                className="flex h-14 w-14 items-center justify-center bg-[#25D366] text-white shadow-lg shadow-black/40 transition-transform duration-200 hover:scale-110"
            >
                <WhatsappLogo size={26} weight="fill" />
            </a>
            <a
                href="tel:+919711220094"
                aria-label="Call Akash Group"
                data-testid="floating-call-button"
                className="flex h-14 w-14 items-center justify-center bg-blaze text-white shadow-lg shadow-black/40 transition-transform duration-200 hover:scale-110"
            >
                <Phone size={24} weight="fill" />
            </a>
        </motion.div>
    );
}
